var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DropMenuBtn',{ref:"profileMenu",on:{"click":_vm.handleClick}}),(_vm.isOpen)?_c('DropMenuContent',{on:{"close":_vm.handleMenuContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }